// @flow strict
import React from 'react';
import './Copyright.scss';

type Props = {
  copyright: string;
};

const Copyright = ({ copyright }: Props) => (
  <React.Fragment>
    <div className="copy-left">&copy;</div>
    <a
      href="https://creativecommons.org/licenses/by-nc-nd/2.0/deed.es"
      target="_blank"
    >
      {' '}
      {copyright}
    </a>
  </React.Fragment>
);

export default Copyright;
